import styled from "styled-components";

export const Bar = styled.div`
  @media (max-width: 767px) {
    justify-content: flex-start;
  }

  @media (max-width: 1239px) {
    margin-bottom: 10px;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  height: max-content;
  background-color: transparent;
  width: 100%;
`;
export const BarMobile = styled.div`
  padding: 10px;
  width: calc(100% - 20px);
  height: max-content;
  position: fixed;
  left: 10px;
  bottom: 10px;
  border-top: 2px solid var(--background);
  border-radius: 10px;
  background-color: white;
  z-index: var(--modal-layer);
`;

export const BarDevice = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  background-color: transparent;
  align-items: center;
  gap: 10px;
  overflow: auto;

  @media (min-width: 1240px) {
    background-color: var(--white);
    flex-direction: column;
    height: max-content;
    // border-radius: 5px;
  }
`;

export const ListForSign = styled.ul<{ $allBtn?: boolean }>`
  display: flex;
  gap: 10px;

  @media (max-width: 1239px) {
    display: grid;
    gap: 10px;

    ${({ $allBtn }) =>
      $allBtn
        ? `
      grid: 1fr 1fr/ 1fr 1fr;
      button:first-child {
        grid-column: 1 / span 2;
      }
    `
        : `display: flex;`}
  }
`;

interface BtnWrapperProps {
  $width?: string;
  $heightMob?: string;
  $widthMob?: string;
  $color?: string;
  $bgColor?: string;
  $height?: string;
}

export const BtnWrapper = styled.button<BtnWrapperProps>`
  @media (max-width: 767px) {
    height: ${(props) => (props.$heightMob ? props.$heightMob : "30px")};
    width: ${(props) => (props.$widthMob ? props.$widthMob : "30px")};
  }
  flex-shrink: 0;
  height: ${(props) => (props.$height ? props.$height : "47px")};
  font-weight: 700;
  width: ${(props) => (props.$width ? props.$width : "47px")};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.$color ? props.$color : "var(--white)")};

  background-color: ${(props) =>
    props.$bgColor ? props.$bgColor : "var(--blue)"};
  &:disabled {
    cursor: default;
    background-color: var(--background);
    color: var(--disabled-c);
  }
  & div {
    padding: 11px 15px;
    @media (max-width: 767px) {
      padding: 7px 13px;
    }
  }
  & span {
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 767px) {
      padding: 7px;
    }
  }
`;

// export const ListForSignDevice = styled.div`
//   display: grid;
//   gap: 1rem;
//   grid-auto-flow: column;
//   width: 100%;
// `;

// export const Btn = styled.button`
//   @media (max-width: 991px) {
//     height: 40px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     width: 100%;
//     margin-right: 0;
//   }
//   &:disabled {
//     background-color: var(--disabled-bg);
//     cursor: default;
//     color: var(--disabled-c);
//   }
//   &:not(:disabled):hover {
//     border: 2px solid var(--background-gray);
//   }
//   height: 46px;
//   width: 170px;
//   margin-right: 20px;
//   background-color: ${(props) => props.$background};
//   color: var(--white);
//   font-size: 14px;
// `;

// export const Rounder = styled.div`
//   &:hover {
//     background-color: var(--red);
//   }
//   height: 40px;
//   width: 40px;
//   background-color: var(--black);
//   border-radius: 50%;
//   margin-right: 20px;
//   cursor: pointer;
// `;

// export const BackBtn = styled(ArrowBackIosNewIcon)`
//   position: relative;
//   top: 50%;
//   left: 45%;
//   transform: translate(-50%, -50%);
//   color: var(--white);
// `;

// export const MobActionBar = styled.div`
//   padding: 12px 20px;
//   display: flex;
//   justify-content: space-between;
//   background-color: #FCFDFF;
// `;
